import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { twMerge } from "tailwind-merge";
export const formInlineContext = createContext(false);
function FormInline(props) {
    return (_jsx(formInlineContext.Provider, { value: true, children: _jsx("div", { ...props, className: twMerge(["block sm:flex items-center", props.className]), children: props.children }) }));
}
export default FormInline;